"use client";

import SUPAKIT from "@/assets/SUPAKIT-V2.png";
import Typewriter from "@/components/ui/Typewriter";
import Image from "next/image";
import { useMemo } from "react";

function getGreetingWords(): string[] {
  const now = new Date();
  const hour = now.getHours();

  // เช็คช่วงเวลา
  let timeOfDay = "";
  let timeOfDayThai = "";
  if (hour >= 5 && hour < 12) {
    timeOfDay = "Morning";
    timeOfDayThai = "เช้า";
  } else if (hour >= 12 && hour < 18) {
    timeOfDay = "Afternoon";
    timeOfDayThai = "บ่าย";
  } else {
    timeOfDay = "Evening/Night";
    timeOfDayThai = "ค่ำ";
  }

  return [
    `Good ${timeOfDay}, My name is SUPAKIT KITJANABUMRUNGSAK...`,
    `สวัสดีตอน${timeOfDayThai} ครับ ผมชื่อ ศุภกิจ กิจนะบำรุงศักดิ์...`,
    `I'm a Software Engineer.`,
  ];
}

function PortfolioHeader() {
  const words = useMemo(() => getGreetingWords(), []);

  return (
    <header className="flex flex-col items-center text-center py-8 px-5 mc-grass-top bg-linear-to-b from-primary/15 to-transparent">
      <div className="grid grid-cols-5 gap-2.5 w-full max-w-5xl justify-center items-center">
        <div className="col-span-3 text-left">
          <p className="mb-3 inline-block mc-slot px-3 py-1 text-sm uppercase tracking-widest text-primary">
            ▸ Player joined the game
          </p>
          <Typewriter texts={words} uppercase />
        </div>
        <div className="col-span-2 flex justify-center">
          <Image
            src={SUPAKIT}
            alt="Supakit"
            height={220}
            width={220}
            loading="lazy"
            className="mc-panel p-1 pixelated animate-mcBob"
          />
        </div>
      </div>
    </header>
  );
}

export default PortfolioHeader;
